// extracted by mini-css-extract-plugin
export default {"basic":"PageMypage_basic__1T0YP","scoreCard":"PageMypage_scoreCard__MSnjM","scoreCardWrapper":"PageMypage_scoreCardWrapper__WnEiz","pageText":"PageMypage_pageText__svhoa"};